<template lang="pug">
  main.erp-view(:id="id")
    header.erp-view-header(:cssClass="blank ? '': 'sticky'")
      nav.erp-view-header-main(v-if="!blank")
        dx-context-menu(:data-source="menu" :width="200" @item-click="clickMenu" target="#touch-menu")
        dx-menu.before.titulo.blanco(:data-source="menu" display-expr="nombre" :onItemClick="clickMenu" :hide-submenu-on-mouse-leave="true")
        .spacer(v-if="touch")
        h2.titulo.blanco(v-if="touch") {{ title }}
        .spacer
        dx-button(icon="fas fa-cloud-download-alt" hint="Forzar recarga" @click="forzarRecarga" styling-mode="text" class="blanco")
        dx-button(icon="fas fa-book-dead" hint="Ver los últimos 10 errores" @click="verErrores" styling-mode="text" class="blanco")
        //dx-button(icon="fas fa-bug" hint="Reportar incidencia en Helpdesk" @click="helpdesk" styling-mode="text" class="blanco")
        dx-button(icon="fas fa-puzzle-piece" hint="Ver módulos" @click="verModulos" styling-mode="text" class="blanco" v-if="!hideApps")
        dx-menu.titulo.blanco(:data-source="opt" :hint="nombreUsuario" display-expr="nombre" :adaptivityEnabled="true" :onItemClick="clickOpcionUsuario" )
      slot(name="header")
        nav.erp-view-header-nav-title(v-if="!hideHeaderTitle && !touch")
          slot(name="header-title")
            h2 {{ title }}
          .spacer
          h3.state(v-if="state") {{ state }}
        nav.erp-view-header-nav-action(v-if="!hideHeaderAction")
          slot(name="header-action")
    section.erp-view-content(:class="blank ? 'content-blank-layout-size' : hideHeaderAction && hideHeaderTitle ? 'content-app-layout-size-wo-header' : hideHeaderAction ? 'content-app-layout-size-wo-action-header' : 'content-app-layout-size'" :style="{backgroundColor: backgroundColor}")
      dx-load-panel(:container="`#${id}`" position="top" :show-indicator="true" :show-pane="true" :shading="true" :visible.sync="loading" shading-color="rgba(0,0,0,0.4)")
      dx-popup(ref="ErpViewErrorPopup" title="Últimos 10 errores" :show-close-button="true")
        dx-scroll-view(width="100%" height="100%")
          dx-data-grid(:data-source="errores" 
            :row-alternation-enabled="true" :show-row-lines="true" :show-borders="true"
            height="350" width="100%" :allow-column-resizing="true" column-resizing-mode="widget" )

            template(#tpl-copiar="{data}")
              dx-button(icon="fas fa-copy" hint="Copiar contenido" @click="copiar(data.data)" styling-mode="text" type="default")

            dx-column(caption="Fecha" data-field="date" width="130" :allow-sorting="false")
            dx-column(caption="Módulo" data-field="app" width="180" :allow-sorting="false")
            dx-column(caption="Mensaje" data-field="msg" :allow-sorting="false")
            dx-column(caption="" cell-template="tpl-copiar" width="100" :allow-sorting="false")

      dx-scroll-view(width="100%" :height="`calc(100vh - ${toolbarsHeight}px)`")
        slot(name="content")
</template>
<script>
import menu from "@/assets/menu.js";
import Permisos from "@/components/seguridad/Permisos.js";
import Gestion from "@/components/seguridad/api/Gestion.js";
import router from "@/router.js";
import { confirm } from "devextreme/ui/dialog";
import MessageBox from "@/components/MessageBox";
import BrowserScan from "@/components/BrowserScan";

export default {
  props: {
    backgroundColor: {
      type: String,
      default: "#fff !important"
    },
    blank: {
      type: Boolean,
      default: false
    },
    popup: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: null,
      required: false
    },
    state: {
      type: String,
      default: null,
      required: false
    },
    hideHeaderAction: {
      type: Boolean,
      default: false
    },
    hideHeaderTitle: {
      type: Boolean,
      default: false
    }
  },
  components: {
    DxLoadPanel: require("devextreme-vue/load-panel").DxLoadPanel,
    DxScrollView: require("devextreme-vue/scroll-view").DxScrollView,
    DxPopup: require("devextreme-vue/popup").DxPopup,
    DxMenu: require("devextreme-vue/menu").DxMenu,
    DxMenuItem: require("devextreme-vue/menu").DxItem,
    DxButton: require("devextreme-vue/button").DxButton,
    DxDataGrid: require("devextreme-vue/data-grid").DxDataGrid,
    DxColumn: require("devextreme-vue/data-grid").DxColumn,
    DxTextArea: require("devextreme-vue/text-area").DxTextArea,
    DxContextMenu: require("devextreme-vue/context-menu").DxContextMenu
  },
  data: () => ({
    touch: BrowserScan.isMobile(),
    Permisos,
    menu,
    errores: [],
    loading: false,
    showFilterPopup: false,
    nombreUsuario: "",
    opt: [
      {
        nombre: "",
        items: [
          { nombre: "Cerrar Sesión", opcion: "cerrarSesion" },
          { nombre: "configuracion de Seguridad", opcion: "configuracionSeguridad" ,
             permiso: "VerConfiguracionSeguridad"} 
        ]
      }
    ],
    hideApps: false
  }),
  created() {
    if (this.$route.name) {
      let routeName = this.$route.name;
      this.hideApps = routeName == "Aplicaciones";
    }
    if (this.$store.state.seguridad.usuario) {

      this.nombreUsuario = this.$store.state.seguridad.usuario.name;
      let iniciales = this.nombreUsuario.split(" ");

      iniciales.forEach(palabra => {
        this.opt[0].nombre += palabra.substr(0, 1);
      });

    }

    let title = document.getElementsByTagName("title")[0];
    
    if (!this.popup) {
      title.innerText = this.title;
    }

    this.opt[0].items = this.opt[0].items
    .map(i => ({
      ...i,
      visible: !i.permiso ? true : this.Permisos.puede(i.permiso)
    }))
    .filter(i => i.visible);

  },
  methods: {
    copiar(obj) {
      let dummy = document.createElement("textarea");
      document.body.appendChild(dummy);
      let jsonStr = JSON.stringify(obj);
      dummy.innerText = jsonStr;
      dummy.value = jsonStr;
      dummy.select();
      document.execCommand("copy");
      document.body.removeChild(dummy);
      MessageBox.info("Copiado", 2000);
    },
    forzarRecarga() {
      location.reload(true);
    },
    verErrores() {
      let obj = localStorage.getItem("carto-errores");
      this.errores = JSON.parse(obj);
      if (this.errores) {
        this.errores = this.errores.reverse();
        this.$refs.ErpViewErrorPopup.instance.show();
      } else {
        alert("No hay errores ... 😱");
      }
    },
    wait(status) {
      let title = document.getElementsByTagName("title")[0];
      if (status || status == undefined) {
        let titulo = this.title;
        title.innerHTML = "🕕 " + (title.innerHTML ? title.innerHTML : titulo);
      } else {
        title.innerHTML = title.innerHTML.replace("🕕 ", "");
      }
      this.loading = status == undefined ? true : status;
    },
    contentHeigth() {
      return !this.popup ? `calc(100vh - ${this.toolbarsHeight()}px` : "auto";
    },
    showFilters(status) {
      console.log(status); //eslint-disable-line
      this.showFilterPopup = status == undefined ? true : status;
    },
    obtenerPermisosMenu(nodo) {
      if (nodo.ruta) {
        let routes = router.options.routes;
        for (let i = 0; i < routes.length; i++) {
          let route = routes[i];
          if (nodo.ruta == route.name) {
            return route.meta.perms;
          }
        }
      } else {
        return [];
      }
    },
    actualizarMenu(nodo) {
      let dev = Permisos.puede("ControlTotal[Dev]");
      if (nodo) {
        nodo.visible = true;
        let permisos = this.obtenerPermisosMenu(nodo) || nodo.permisos || [];
        if (permisos) {
          permisos.forEach(p => {
            nodo.visible = dev || (nodo.visible && Permisos.puede(p));
          });
        }
      }
      if (nodo.items) {
        nodo.items = nodo.items.map(item => this.actualizarMenu(item));
        let visiblePadre = false;
        nodo.items.forEach(item => {
          visiblePadre = visiblePadre || item.visible;
        });
        nodo.visible = visiblePadre;
      }
      return nodo;
    },
    clickMenu(e) {
      let ruta = e.itemData.ruta;
      if (ruta) {
        if (this.$route && this.$route.name != ruta) {
          this.$router.push({ name: ruta });
        }
      }
    },
    clickOpcionUsuario(e) {
      if (e.itemData.opcion) {
        this[e.itemData.opcion]();
      }
    },
  cerrarSesion() {
  confirm(` ¿Seguro que deseas cerrar sesión? `, `Confirmación`).then(async ok => {
    if (ok) {
      await Gestion.cerrarSesion();         // 🔥 primero cerrar en JAVA
      this.$store.commit("seguridad/cerrarSesion");
      this.$router.replace({ name: "Login" });
    }
  });
},

    configuracionSeguridad() {  
        this.$router.replace({ name: "ConfiguracionSeguridad" }); 
    },
    cambiarContrasena() {
      this.$router.replace({ name: "CambiarContrasena" });
    },
    verModulos() {
      this.$router.push({ name: "Aplicaciones" });
    },
    helpdesk() {
      window.open(
        "http://www.cartonesdelpacifico.com.pe/helpdesk/login_select_proj_page.php?ref=bug_report_page.php",
        "_blank"
      );
    }
  },
  watch: {
    title(val) {
      console.log(val, this.popup); //eslint-disable-line
      if (val && val != "") {
        let title = document.getElementsByTagName("title")[0];
        if (!this.popup) {
          title.innerText = `${val}`;
        }
      }
    }
  },
  computed: {
    toolbarsHeight() {
      let toolbars = 0;
      toolbars += !this.hideHeaderAction ? 40 : 0;
      toolbars += !this.hideHeaderTitle ? 35 : 0;
      return toolbars + 35;
    }
  }
};
</script>
<style>
* {
  font-family: "Helvetica Neue", "Segoe UI", Helvetica, Verdana, sans-serif;
}
.erp-view {
  height: 100%;
}

.erp-view-header {
  z-index: 97;
  box-sizing: border-box !important;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.2);
  top: 0px;
  z-index: 98;
}

.sticky {
  position: sticky !important;
}

.erp-view-header-nav-title {
  padding-top: 4px;
  padding-left: 5px;
  padding-right: 5px;
  height: 35px;
  background-color: #f5f5f5;
  display: flex;
}

.erp-view-header-nav-title > * {
  font-size: 16px !important;
  font-weight: 500;
  margin: 0;
  color: #555;
}

.erp-view-header-nav-title > a {
  color: #337ab7 !important;
  text-decoration: none;
}

.erp-view-header-main > .spacer,
.erp-view-header-nav-action > .spacer,
.erp-view-header-nav-title > .spacer {
  margin-left: auto;
}

.erp-view-header-nav-action > .separator::before,
.erp-view-header-nav-title > .separator::before {
  color: #ccc;
  margin: 0px 3px;
  content: "|";
  box-sizing: border-box;
}

.erp-view-header-main,
.erp-view-header-nav-action {
  width: 100%;
  overflow: auto;
  padding: 0px 5px;
  height: 40px;
  background-color: #f5f5f5;
  white-space: nowrap;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: -ms-autohiding-scrollbar;
  line-height: 2.5em;
  display: flex;
}

.erp-view-header-main {
  padding: 0px;
}

.erp-view-header-main {
  background-color: #29a9e5;
  height: 35px;
}

.erp-view-header-main .dx-menu .dx-menu-item {
  color: white !important;
}

.erp-view-header-main .dx-menu .dx-menu-item-expanded {
  color: #2068af !important;
}

.erp-view-header-main > .titulo {
  font-weight: 400;
  font-size: 1.1em !important;
}

.blanco,
.blanco .dx-icon {
  color: white !important;
}

.erp-view-header-main::-webkit-scrollbar,
.erp-view-header-nav-action::-webkit-scrollbar {
  display: none;
}
/*
.erp-view-header-main > :not(:first-child),
.erp-view-header-nav-action > :not(:first-child) {
  margin-left: 5px;
}*/

/*.erp-view-header-main > *,*/
.erp-view-header-nav-title > *,
.erp-view-header-nav-action > * {
  margin: 3px;
  margin-left: 0px;
}

.before {
  float: left;
}

.after {
  float: right;
}

.erp-view-content {
  padding-right: 5px;
  padding-left: 5px;
  margin-bottom: 0px;
  height: 100%;
}

.content-blank-layout-size {
  height: calc(100vh);
}

.content-app-layout-size-wo-action-header {
  height: calc(100vh - 71px) !important;
}

.content-app-layout-size-wo-header {
  height: calc(100vh - 36px) !important;
}

.content-app-layout-size {
  height: calc(100vh - 111px) !important;
}

.link {
  color: #208ece;
  text-decoration: underline;
  cursor: pointer;
  font-weight: 400;
}

.action {
  color: #208ece;
  text-decoration: none;
  cursor: pointer;
  font-weight: 500;
}

.required:after {
  content: "*";
  color: red;
  font-weight: 500;
}

.mergecells {
  display: table-cell;
  vertical-align: middle !important;
}

.state {
  padding: 5px;
  margin: 0;
  box-sizing: border-box;
  background-color: #545454;
  color: white;
  border-radius: 10px;
}

/* Estilos child EdGrid */
.ed-grid {
  max-width: none !important;
}

.ed-grid > label {
  align-items: center;
  display: flex;
  font-weight: 500;
}

.ed-grid > label.field {
  font-weight: 400;
  min-height: 36px;
}

/* Estilos de DevExtreme chancados*/
.dx-header-filter {
  color: #ff6a00 !important;
}

.dx-header-filter-empty {
  color: #959595 !important;
}

.dx-popup-content {
  padding: 0px !important;
}

.dx-button {
  font-weight: 500;
}

.dx-dialog-message {
  padding: 10px !important;
}

.dx-checkbox-text {
  line-height: 2.5em;
}

.dx-group-row {
  color: #4a4a4a !important;
  background-color: #e6e6e6 !important;
}

.editable {
  background-color: #fbffb6 !important;
}

.dx-row-alt > .editable {
  background-color: #f2f5c2 !important;
}

.dx-group-row > .editable {
  color: #4a4a4a;
  background-color: #e6e6e6 !important;
}

.no-editable {
  background-color: #f5f5f5 !important;
}

.dx-row-alt > .no-editable {
  background-color: #f5f5f5 !important;
}

.dx-group-row > .no-editable {
  color: #4a4a4a;
  background-color: #f5f5f5 !important;
}

.subtitulo {
  font-size: 18px !important;
  font-weight: 500;
}

.menu-dropdown .dx-buttongroup-wrapper {
  height: 100% !important;
  background-color: white;
}

.dx-dropdownbutton-popup-wrapper .dx-item {
  line-height: 2.1em !important;
  font-weight: 500;
}

.dx-pivotgrid .dx-pivotgrid-area td {
  color: #333;
}
</style>
